import { render } from "./LinkItem.vue?vue&type=template&id=0e6c5da2&scoped=true"
import script from "./LinkItem.vue?vue&type=script&lang=js"
export * from "./LinkItem.vue?vue&type=script&lang=js"

import "./LinkItem.vue?vue&type=style&index=0&id=0e6c5da2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e6c5da2"]])

export default __exports__